const e = `Het gaat hierbij om extra uitgaven t.o.v. de afgelopen 12 maanden zoals bijvoorbeeld:
<ul>
<li>Hogere energiekosten</li>
<li>Hogere (vervangings)investeringen</li>
<li>Grotere uitgaven aan voorraad</li>
<li>Belastingschulden</li>
<li>Slottermijn leases</li>
</ul>
Let op! De volgende zaken vallen hier niet onder:
<ul>
<li>Extra uitgaven die betaald worden met de aangevraagde financiering</li>
<li>Vernieuwen van leasecontracten of overige financiële verplichtingen zolang je maandelijkse uitgaven hetzelfde blijven</li>
</ul>`, n = `Je kan een financiering aanvragen als:
<ul>
<li>Je minimaal 12 maanden aan transactiegegevens kunt delen op basis waarvan we jouw mogelijkheden kunnen berekenen.</li>
<li>Je bedrijf gevestigd is in Nederland en actief is in een sector die wij kunnen financieren.</li>
<li>Je bedrijf één van de volgende rechtsvormen heeft: VOF, eenmanszaak, maatschap of een B.V. en is ingeschreven bij de Kamer van Koophandel.</li>
</ul>`, a = `Zowel B2B als B2C facturen komen in aanmerking. Je factuur moet aan de volgende voorwaarden voldoen om gefinancierd te worden met Factuur Financiering:
<ul>
<li>De factuur is maximaal 10 kalenderdagen oud;</li>
<li> De goederen en/of diensten waarvoor gefactureerd wordt zijn reeds geleverd;</li>
<li>De factuur die je wilt financieren is niet verpand, gefinancierd of overgedragen, bijvoorbeeld aan een andere bank;</li>
<li>De factuur is gericht aan een in de Kamer van Koophandel ingeschreven bedrijf of particulier woonachtig in Nederland. Facturen naar het buitenland komen dus niet in aanmerking;</li>
<li>De factuur heeft een betalingstermijn van maximaal 90 dagen.</li>
<li>Het factuurbedrag ligt tussen de €1.000 en €100.000;</li>
<li> Uit de omschrijving op de factuur is op te maken wat de aard van de activiteit is waarvoor wordt gefactureerd (bijv. ''conform offerte'' is onvoldoende).</li>
</ul>`, i = {
  text_65f0d89e6fca7d7a5f9dfe41: e,
  text_6600cda50861cc0108cb6da6: n,
  text_6600cda50861cc0108cb6da8: a,
  "__variant-name": "base.dev",
  "__variant-description": ""
};
export {
  i as default,
  e as text_65f0d89e6fca7d7a5f9dfe41,
  n as text_6600cda50861cc0108cb6da6,
  a as text_6600cda50861cc0108cb6da8
};
